var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWear4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5442 82.6335H59.3502L54.3069 40.431C52.6756 39.908 52.7005 42.1993 52.5012 43.3449C50.3095 56.1713 49.911 69.4584 47.4454 82.2599C47.0345 82.8327 38.0311 83.2561 37.4956 81.5875L39.1643 54.5649L42.3397 22.1503C47.271 23.1465 52.0529 23.7318 57.1336 23.408C58.8272 23.2959 63.9702 21.5401 64.7299 22.7605C67.5068 42.5978 68.7397 62.6219 67.5442 82.6335Z",
    fill: "#0256B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWear4);
export default __webpack_public_path__ + "static/media/wear4.d7cb034c022d83dada3b31272b88bbf5.svg";
export { ForwardRef as ReactComponent };